import { SessionStorageUsable } from 'infrastructure/storages/SessionStorageUsable';
import { ISessionStorageUsable } from 'interfaceAdapter/gatewaySchemas/ISessionStorageUsable';
import {
    IValuationEstimateStorageRepository,
    ValuationEstimateData,
} from 'application/repositorySchemas/IValuationEstimateStorageRepository';

const KEY = 'valuation_estimate';
const PREFIX = 'ma_';

export class ValuationEstimateStorageRepository implements IValuationEstimateStorageRepository {
    constructor(private readonly storage: ISessionStorageUsable = new SessionStorageUsable(PREFIX, KEY)) {}

    public get(): ValuationEstimateData | null {
        const data = this.storage.get();
        if (!data) {
            return null;
        }
        try {
            return JSON.parse(data) as ValuationEstimateData;
        } catch {
            return null;
        }
    }

    public set(data: ValuationEstimateData): void {
        this.storage.set(JSON.stringify(data));
    }

    public remove(): void {
        this.storage.remove();
    }
}
